import { Outlet, Link } from "remix";
import {
  Center,
  Container,
  HeaderContainer,
  HeaderLinksContainer,
  Logo,
} from "~/components";

export default function AccountLayout() {
  return (
    <Container>
      <HeaderContainer>
        <div>
          <Link to="/">
            <Logo />
          </Link>
        </div>
        <HeaderLinksContainer>
          <Link to="/account/signin">Login</Link>
          <Link to="/account/signup">Register</Link>
        </HeaderLinksContainer>
      </HeaderContainer>
      <div>
        <Outlet />
      </div>
    </Container>
  );
}
